var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "px-6" },
    [
      _c("paginator", {
        attrs: { "data-url": "/customer/orders/list" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (props) {
              return [
                _c("div", { staticClass: "flex flex-col" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200",
                        },
                        [
                          _c("table", { staticClass: "min-w-full" }, [
                            _c("thead", [
                              _c("tr", { staticClass: "whitespace-no-wrap" }, [
                                _c(
                                  "th",
                                  {
                                    staticClass:
                                      "w-px px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                #\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticClass:
                                      "px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                Total\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticClass:
                                      "px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                Fulfilment Status\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "th",
                                  {
                                    staticClass:
                                      "w-px px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                Last Updated\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("th", {
                                  staticClass: "px-6 py-3 bg-gray-50",
                                }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              { staticClass: "bg-white" },
                              _vm._l(props.items, function (order) {
                                return _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "px-6 py-4 whitespace-no-wrap border-t border-gray-200 text-sm leading-5 font-medium text-gray-900",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(order.id) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "px-6 py-4 whitespace-no-wrap border-t border-gray-200 text-sm leading-5 text-gray-500",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                £" +
                                          _vm._s(
                                            order.formatted_total_with_credit_applied
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "px-6 py-4 whitespace-no-wrap border-t border-gray-200 text-sm leading-5 text-gray-500",
                                    },
                                    [
                                      order.status === 0
                                        ? _c(
                                            "badge",
                                            { attrs: { color: "red" } },
                                            [
                                              _vm._v(
                                                "\n                                    Unfulfilled\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      order.status === 1
                                        ? _c(
                                            "badge",
                                            { attrs: { color: "green" } },
                                            [
                                              _vm._v(
                                                "\n                                    Fulfilled\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      order.status === 2
                                        ? _c(
                                            "badge",
                                            { attrs: { color: "gray" } },
                                            [
                                              _vm._v(
                                                "\n                                    Cancelled\n                                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "px-6 py-4 whitespace-no-wrap border-t border-gray-200 text-sm leading-5 text-gray-500",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(order.last_updated) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "px-6 py-4 whitespace-no-wrap text-right border-t border-gray-200 text-sm leading-5 font-medium",
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-primary-600 hover:text-primary-700",
                                          attrs: {
                                            href: _vm.route(
                                              "customer.order.show",
                                              order.id
                                            ),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    View\n                                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              }),
                              0
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }